import { CompleteTaskResponseSchema } from './complete-task.schema';
/**
 * Complete Task Endpoint Contract
 * The assignee (or a manager) marks a task done.
 */ export const completeTaskContract = {
    method: 'POST',
    path: '/api/v2/task/:id/complete',
    description: 'Mark a task as done',
    responseSchema: CompleteTaskResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Task is no longer open',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user may not complete this task',
            404: 'Task not found'
        }
    }
};

//# sourceMappingURL=complete-task.contract.js.map